import { useContext } from 'react';

import { RouterContext } from '../Router';

import loggerGenerator from '@travel/logger';

const logger = loggerGenerator();

export const useHistory = () => {
  const routerValue = useContext(RouterContext);

  if (typeof routerValue === 'undefined') {
    logger.error(
      "[RouterContext] Couldn't find a context value; Please make sure to use it within <RouterContext.Provider>",
    );

    return;
  }

  return routerValue.history;
};
